<template>
  <div class="JNPF-common-layout-header">
    <div class="header-logo"></div>

    <div class="header-banner">
      <template v-for="(item, index) in banner">
        <div :key="index" class="header-banner-item">
          <img :src="item.src" alt="">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "RAXHeader",
  data() {
    return {
      banner: [
        {
          src: require('@/assets/images/banner.jpg')
        }
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.JNPF-common-layout-header{
  width: 100%;

  .header-logo{
    width: 100%;
    height: 90px;
    background: url("~@/assets/images/top_logo.jpg") no-repeat left top/cover;
  }

  .header-banner{
    width: 100%;
    height: 150px;

    .header-banner-item{
      width: 100%;

      img{
        display: block;
        width: 100%;
        height: 150px;
      }
    }
  }
}
</style>
